module.exports = __webpack_public_path__ + "img/imagem-mapa.8834317f.png";